import { memo } from 'react'

import classnames from 'classnames'

import { Props } from './types'

import '@hotmart/cosmos/dist/button/button.css'
import '@hotmart/cosmos/dist/button/variations/primary.css'
import '@hotmart/cosmos/dist/button/variations/secondary.css'
import '@hotmart/cosmos/dist/button/variations/info.css'
import '@hotmart/cosmos/dist/button/variations/success.css'
import '@hotmart/cosmos/dist/button/variations/danger.css'
import '@hotmart/cosmos/dist/styles/utilities/text/text.css'
import '@hotmart/cosmos/dist/styles/utilities/sizing/sizing.css'
import '@hotmart/cosmos/dist/styles/utilities/flex/flex.css'
import './button.scss'

const Button = ({
  children,
  onClick,
  variant,
  type = 'button',
  disabled = false,
  className = '',
  trailing = null,
  leading = null,
  loading = false,
  outline = false,
  ...others
}: Props) => {
  const classes = classnames('hot-button', className, {
    [`hot-button--${variant}`]: Boolean(variant),
    'hot-button--loading': loading,
    'is-outline': outline
  })

  const leadingClasses = '_text-2 _align-items-center _d-inline-flex'

  return (
    <button type={type} disabled={disabled} onClick={onClick} className={classes} {...others}>
      {leading && <span className={classnames('leading _mr-2', leadingClasses)}>{leading}</span>}
      {children}
      {trailing && <span className={classnames('trailing _ml-2', leadingClasses)}>{trailing}</span>}
    </button>
  )
}

export default memo(Button)
